import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, pct, thb, TIER_LABELS, type Tier } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function PrintPage() {
  const { tier: tierParam } = useParams<{ tier: string }>();
  const { user } = useAuth();
  const [data, setData] = useState<{ rows: any[]; tiers: Tier[]; username: string } | null>(null);

  useEffect(() => {
    api.exportAll().then(setData);
  }, []);

  if (!data || !user) {
    return <div className="grid min-h-screen place-items-center text-sm">กำลังเตรียมหน้าพิมพ์…</div>;
  }

  const tiers: Tier[] = (data.tiers as Tier[]).filter((t) => !tierParam || tierParam === "all" || t === tierParam);
  const stamp = new Date().toLocaleDateString("th-TH");

  return (
    <div className="bg-white text-black">
      <header className="bg-beijer-dark px-8 py-5 text-white print:bg-beijer-dark">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logos/beijer-bgrimm-white.png" alt="Beijer B Grimm" className="h-9" />
            <div>
              <div className="font-display text-[10px] uppercase tracking-[0.18em] opacity-80">พอร์ทัลราคาขาย BBT</div>
              <div className="font-display text-base font-bold">Master Sale Price 2026</div>
            </div>
          </div>
          <div className="text-right text-xs">
            <div className="font-mono">ผู้ใช้ · {data.username}</div>
            <div>วันที่ {stamp}</div>
          </div>
        </div>
      </header>
      <div className="bg-accent-orange" style={{ height: "2px" }} />

      <main className="px-8 py-6">
        <div className="mb-3 text-sm">
          ระดับราคา: <strong>{tiers.map((t) => TIER_LABELS[t]).join(" · ")}</strong> · {data.rows.length.toLocaleString()} รายการ
        </div>
        <table className="w-full text-[10pt]">
          <thead>
            <tr className="bg-beijer text-left text-white">
              <th className="px-2 py-1.5">รหัสสินค้า</th>
              <th className="px-2 py-1.5">ชื่อรายการ</th>
              <th className="px-2 py-1.5">แบรนด์</th>
              <th className="px-2 py-1.5">กลุ่ม</th>
              <th className="px-2 py-1.5 text-right">สต๊อก</th>
              <th className="px-2 py-1.5 text-right">ราคาตั้ง</th>
              {tiers.map((t) => (
                <th key={t} className="px-2 py-1.5 text-right">{TIER_LABELS[t]}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r, i) => (
              <tr key={r.partnumber} className={i % 2 ? "bg-beijer/5" : ""}>
                <td className="px-2 py-1 font-mono text-[9pt]">{r.partnumber}</td>
                <td className="px-2 py-1">{r.description ?? "—"}</td>
                <td className="px-2 py-1 text-[9pt] text-gray-600">{r.brand1 ?? "—"}</td>
                <td className="px-2 py-1 text-[9pt] text-gray-600">{r.product1 ?? "—"}</td>
                <td className="px-2 py-1 text-right">{r.bc_inv?.available ?? r.stock ?? 0}</td>
                <td className="px-2 py-1 text-right font-mono text-[9pt]">{thb(r.sale_price)}</td>
                {tiers.map((t) => {
                  const isNet = r[`${t}_is_net`] === 1;
                  const disc = r[`${t}_disc`];
                  const up = r[`${t}_unit_price`];
                  return (
                    <td key={t} className="px-2 py-1 text-right font-mono">
                      {up == null && !isNet ? "—" : (
                        <>
                          <span className="font-semibold">{thb(up)}</span>
                          <span className="ml-1 text-[8pt] text-gray-500">{isNet ? "NET" : `−${pct(disc)}`}</span>
                        </>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </main>

      <div className="no-print fixed bottom-4 right-4 z-50 flex gap-2">
        <button className="rounded-full bg-beijer px-4 py-2 text-sm font-semibold text-white shadow-lg" onClick={() => window.print()}>พิมพ์ / บันทึกเป็น PDF</button>
        <button className="rounded-full border border-border bg-background px-4 py-2 text-sm" onClick={() => history.back()}>ย้อนกลับ</button>
      </div>
    </div>
  );
}
